import React from 'react';
import PropTypes from 'prop-types';

const ConditionalWrapper = ({ children, condition = false, wrapper }) =>
	condition ? wrapper(children) : <>{children}</>;

ConditionalWrapper.propTypes = {
	children: PropTypes.node.isRequired,
	condition: PropTypes.bool,
	wrapper: PropTypes.func.isRequired,
};

export default ConditionalWrapper;
